import React from 'react';

import { ArrowRightIcon } from '../../../Icons/ArrowRightIcon';
import { Button, IButtonProps } from '../../Buttons/Button';
import { ControlLikeVariant } from '../../variants';

interface IProps extends Omit<IButtonProps, 'size'> {
  variant: ControlLikeVariant;
  children?: React.JSX.Element;
}

export const ForwardButton = (props: IProps) => {
  const { children, ...rest } = props;
  return (
    <Button aria-label="Forward" {...rest}>
      <ArrowRightIcon />
      {children}
    </Button>
  );
};
